type FaqItem = { answer: string; question: string };

export const faqItems: FaqItem[] = [
  {
    answer:
      "No. Just walk in during open hours, scan a car, and you're driving in minutes.",
    question: 'Do I need an appointment?'
  },
  {
    answer:
      'None. No salespeople, no commissions. An advocate pulls the car around, then you drive it solo with no one riding along.',
    question: 'Is there any pressure to buy?'
  },
  {
    answer:
      'Every brand-new Jeep, Dodge, Ram, and Chrysler on the lot. Drive as many as you like in one visit.',
    question: 'Which cars can I drive?'
  },
  {
    answer:
      "Finish the purchase on your phone. We'll deliver to your driveway, or drive it home the same day.",
    question: 'What if I want to buy?'
  }
];
